import { createSlice } from "@reduxjs/toolkit"

import { logout } from "../../LoginPage/redux/auth.thunks.ts"
import type { SelfDeletionState } from "../types/types.ts"
import {
  cancelSelfDeletion,
  fetchSelfDeletionStatus
} from "./deletion-lock.thunks.ts"

const initialState: SelfDeletionState = {
  status: null,
  reason_id: null,
  admin_comment: null,
  created_at: null,
  decided_at: null,
  fetched: false,
  fetching: false,
  cancelling: false
}

const selfDeletionSlice = createSlice({
  name: "selfDeletion",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSelfDeletionStatus.pending, (state) => {
        state.fetching = true
      })
      .addCase(fetchSelfDeletionStatus.fulfilled, (state, action) => {
        state.fetching = false
        state.fetched = true
        state.status = action.payload?.status ?? "none"
        state.reason_id = action.payload?.reason_id ?? null
        state.admin_comment = action.payload?.admin_comment ?? null
        state.created_at = action.payload?.created_at ?? null
        state.decided_at = action.payload?.decided_at ?? null
      })
      .addCase(fetchSelfDeletionStatus.rejected, (state) => {
        state.fetching = false
        // Fail open. Blocking on an unknown status would turn one bad response
        // from this endpoint into a total lock-out of every user; letting a
        // pending-deletion user through is the far smaller harm, and matches
        // what mobile does.
        state.fetched = true
        state.status = null
      })

      .addCase(cancelSelfDeletion.pending, (state) => {
        state.cancelling = true
      })
      .addCase(cancelSelfDeletion.fulfilled, (state) => {
        state.cancelling = false
      })
      .addCase(cancelSelfDeletion.rejected, (state) => {
        state.cancelling = false
      })

      .addCase(logout.fulfilled, () => initialState)
  }
})

export default selfDeletionSlice
